import { render, staticRenderFns } from "./PanelContent.vue?vue&type=template&id=0c2e3a15&scoped=true&"
import script from "./PanelContent.vue?vue&type=script&lang=js&"
export * from "./PanelContent.vue?vue&type=script&lang=js&"
import style0 from "./PanelContent.vue?vue&type=style&index=0&id=0c2e3a15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2e3a15",
  null
  
)

export default component.exports